import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { Row } from '@/design-system/components/layout';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { IssueCardStackParamList } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import moment from 'moment-timezone';
import { CardIssueTypeFilters } from '../../options';

export interface IssueCardProps {
  onClose: () => void;
  data: any;
  account: string;
  tab?: number;
  returnData?: any;
  refresh?: () => void;
}

export const IssueCardNativeTwoScreen: React.FC<IssueCardProps> = (props) => {
  const { onClose, data, account, tab, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    btnView,
    btn,
    textHeaderTitle,
    textHeaderSubTitle,
    modal
  } = sxStyles;

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<IssueCardStackParamList>>();

  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::issue-card.instruction-form.title--issue-card')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={modal}>
        <View sx={topHeader}>
          <Icon name="checkCircleBlue" height={80} width={80} />
          <H6 bold sx={textHeaderTitle}>
            {t('card-account-management::issue-card.instruction-form.title--new-instruction-placed')}
          </H6>
          <TextCaption sx={textHeaderSubTitle}>
            {t('card-account-management::issue-card.instruction-form.text--you-have-issued-a-new-card')}
          </TextCaption>
        </View>
        <View sx={body}>
          <View sx={{ gap: '$5' }}>
            <View>
              <TextCaption sx={textTitle} semiBold>
                {t('card-account-management::issue-card.instruction-form.product-name')}
              </TextCaption>
              <H6 sx={textAtmPin}>{returnData?.product?.name || '-'}</H6>
            </View>
            <View>
              <TextCaption sx={textTitle} semiBold>
                {t('card-account-management::issue-card.instruction-form.card-number-last-four-digits')}
              </TextCaption>
              <H6 sx={textAtmPin}>{returnData.last4 || '-'}</H6>
            </View>
            <View>
              <TextCaption sx={textTitle} semiBold>
                {t('card-account-management::issue-card.instruction-form.text--embossed-name')}
              </TextCaption>
              <H6 sx={textAtmPin}>{returnData.embossedName}</H6>
            </View>
            <View>
              <TextCaption sx={textTitle} semiBold>
                {t('card-account-management::issue-card.instruction-form.expiry-date')}
              </TextCaption>
              <H6 sx={textAtmPin}>{`${returnData.expiryMonth || '-'}/${
                (returnData.expiryYear || '').substring((returnData.expiryYear?.length || 0) - 2 || 0) || '-'
              }`}</H6>
            </View>
            <View sx={horizontalWrapper}>
              <TextBody sx={textLabel}>{t('card-account-management::lock-card.text--instruction-time')}</TextBody>
              <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
            </View>
          </View>
          <View sx={btnView}>
            <UniButton
              sx={btn}
              labelSx={{ color: '$balck' }}
              label={t('card-account-management::general.button--close')}
              onPress={() => {
                refresh();
                navigation.getParent()?.goBack();
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    padding: '$5'
  },
  topHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault'
  },
  body: {
    py: 28
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  btnView: {
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 20
  },
  btn: {
    width: '100%',
    height: 44
  },
  textHeaderTitle: {
    mb: '$2',
    textAlign: 'center'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  }
};
